module.exports = __webpack_public_path__ + "img/re_lod_photo.d210529c.png";